// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

export interface SymbolConfig {
  color?: string; // Hex string preferred
  size?: number; // for points
  width?: number; // for lines
  angle?: number; // angle to rotate the symbol
  outlineColor?: string;
  outlineWidth?: number;
  Fill?: string | 'none';
  style?: string;
}

export interface LayerStyleConfig {
  geometryType: 'point' | 'polyline' | 'polygon';
  symbol: SymbolConfig;
  RendererType?: 'SimpleMarker' | 'Simple';
}

export interface StyleConfig {
  defaults: {
    point: LayerStyleConfig;
    polyline: LayerStyleConfig;
    polygon: LayerStyleConfig;
  };
  layers: Record<string, LayerStyleConfig>;
}

export const styleConfig: StyleConfig = {
  // default style configuration
  defaults: {
    point: {
      geometryType: 'point',
      symbol: {
        color: '#0078D4',
        size: 8,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    polyline: {
      geometryType: 'polyline',
      symbol: {
        color: '#0078D4',
        width: 2,
      },
      RendererType: 'Simple',
    },
    polygon: {
      geometryType: 'polygon',
      symbol: {
        color: '#0078D4',
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
  },
  // Style configuration for specific layers.
  // Style configuration for new layers can be added here
  layers: {
    'D-UP-BOTTOM': {
      geometryType: 'point',
      symbol: {
        color: '#00BDBD',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'D-UP-TOP': {
      geometryType: 'point',
      symbol: {
        color: '#FFAAAA',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'R-RR-CROSSGUARD': {
      geometryType: 'point',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Centered Hexagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'R-RR-MILE-POST': {
      geometryType: 'point',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Centered Hexagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'S-BOLLARD': {
      geometryType: 'point',
      symbol: {
        color: '#FFAABF',
        Fill: 'none',
        style: 'Centered Hexagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'S-SIGN': {
      geometryType: 'point',
      symbol: {
        color: '#FF00BF',
        Fill: 'none',
        style: 'Centered Star',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'S-TOWER': {
      geometryType: 'point',
      symbol: {
        color: '#BD00BD',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_GROUND_CLEARANCE: {
      geometryType: 'point',
      symbol: {
        color: '#000000',
        Fill: 'none',
        style: 'Standing Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    T_LOWEST_LINE_SAG: {
      geometryType: 'point',
      symbol: {
        color: '#000000',
        Fill: 'none',
        style: 'Standing Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-ANTENNA-TOP': {
      geometryType: 'point',
      symbol: {
        color: '#FF73DF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-COMM-BOX': {
      geometryType: 'point',
      symbol: {
        color: '#B2B2B2',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-COMM-POA': {
      geometryType: 'point',
      symbol: {
        color: '#FF5500',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-CROSSARM': {
      geometryType: 'point',
      symbol: {
        color: '#FF00FF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-GUY-ANCHOR': {
      geometryType: 'point',
      symbol: {
        color: '#55FF00',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-GUY-POA': {
      geometryType: 'point',
      symbol: {
        color: '#55FF00',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-LP-BOTTOM': {
      geometryType: 'point',
      symbol: {
        color: '#E6E600',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-POWER-POA': {
      geometryType: 'point',
      symbol: {
        color: '#0070FF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-RISER': {
      geometryType: 'point',
      symbol: {
        color: '#C500FF',
        Fill: 'none',
        style: 'Centered Diamond Wide',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-SIGNAL-BOTTOM': {
      geometryType: 'point',
      symbol: {
        color: '#00C5FF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-STREETLIGHT-BOTTOM': {
      geometryType: 'point',
      symbol: {
        color: '#E6E600',
        Fill: 'none',
        style: 'Centered Triangle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-STREETLIGHT-DRIP': {
      geometryType: 'point',
      symbol: {
        color: '#E6E600',
        Fill: 'none',
        style: 'Centered Diamond',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-STREETLIGHT-TOP': {
      geometryType: 'point',
      symbol: {
        color: '#E6E600',
        Fill: 'none',
        style: 'Centered Triangle',
        size: 10,
        angle: 180,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-TOWER-BOTTOM': {
      geometryType: 'point',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-TRANSFORMER': {
      geometryType: 'point',
      symbol: {
        color: '#00FFC5',
        Fill: 'none',
        style: 'Centered Rounded Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-TRANSFORMER-DRIP': {
      geometryType: 'point',
      symbol: {
        color: '#00FFC5',
        Fill: 'none',
        style: 'Centered Diamond',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-UP-BOTTOM': {
      geometryType: 'point',
      symbol: {
        color: '#000000',
        Fill: 'none',
        style: 'Telecom',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-UP-TOP': {
      geometryType: 'point',
      symbol: {
        color: '#FFFF00',
        Fill: 'none',
        style: 'Centered Circle',
        size: 6,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'T-WEATHER-HD': {
      geometryType: 'point',
      symbol: {
        color: '#C500FF',
        Fill: 'none',
        style: 'Centered Octagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-CATCHBASIN': {
      geometryType: 'point',
      symbol: {
        color: '#00FF00',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-CULVERT': {
      geometryType: 'point',
      symbol: {
        color: '#008DBD',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-GAS-METER': {
      geometryType: 'point',
      symbol: {
        color: '#7EBDAD',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-HANDHOLE': {
      geometryType: 'point',
      symbol: {
        color: '#7E8DBD',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-HYDRANT': {
      geometryType: 'point',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Centered Triangle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-LANDMARK': {
      geometryType: 'point',
      symbol: {
        color: '#815681',
        Fill: 'none',
        style: 'Centered Hexagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-MANHOLE': {
      geometryType: 'point',
      symbol: {
        color: '#0000FF',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-MARKER': {
      geometryType: 'point',
      symbol: {
        color: '#00FF7F',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-MILE-MARKER': {
      geometryType: 'point',
      symbol: {
        color: '#600081',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-PEDESTAL': {
      geometryType: 'point',
      symbol: {
        color: '#FFEAAA',
        Fill: 'none',
        style: 'Centered Hexagon',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-POLE-LIGHT': {
      geometryType: 'point',
      symbol: {
        color: '#FF3F00',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-POLE-SIGNAL': {
      geometryType: 'point',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Centered Triangle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-POLE-UTILITY': {
      geometryType: 'point',
      symbol: {
        color: '#810000',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-TELCO-TOWER': {
      geometryType: 'point',
      symbol: {
        color: '#FF003F',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-TRANSMISSION-POLE': {
      geometryType: 'point',
      symbol: {
        color: '#FF003F',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-VALVE': {
      geometryType: 'point',
      symbol: {
        color: '#FF7F00',
        Fill: 'none',
        style: 'Centered Circle',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'U-VAULT': {
      geometryType: 'point',
      symbol: {
        color: '#005EBD',
        Fill: 'none',
        style: 'Centered Square',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'V-BUSH': {
      geometryType: 'point',
      symbol: {
        color: '#6834',
        Fill: 'none',
        style: 'Park',
        size: 6,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'V-SPark': {
      geometryType: 'point',
      symbol: {
        color: '#00BD00',
        Fill: 'none',
        style: 'Park',
        size: 10,
        outlineColor: '#000000',
        outlineWidth: 1,
      },
      RendererType: 'SimpleMarker',
    },
    'A-OBSTRUCTION': {
      geometryType: 'polygon',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FF0000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'A-PARCEL': {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'A-ROAD-SHOULDER': {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'A-ROW': {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'B-OVERHANG': {
      geometryType: 'polygon',
      symbol: {
        color: '#00FF00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FF00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'B-OVERHANG-A': {
      geometryType: 'polygon',
      symbol: {
        color: '#00FF00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FF00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'B-OVERHANG-OTHER': {
      geometryType: 'polygon',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FF0000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'C-CONC-PAD': {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFFAA',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFFAA',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-ADA': {
      geometryType: 'polygon',
      symbol: {
        color: '#FF007F',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FF007F',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-BRIDGE': {
      geometryType: 'polygon',
      symbol: {
        color: '#BD0000',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BD0000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-CURB': {
      geometryType: 'polygon',
      symbol: {
        color: '#FF00FF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FF00FF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-CURB-BERM': {
      geometryType: 'polygon',
      symbol: {
        color: '#680068',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#680068',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-DRIVEWAY-ASPH': {
      geometryType: 'polygon',
      symbol: {
        color: '#BFAAFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BFAAFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-DRIVEWAY-CONC': {
      geometryType: 'polygon',
      symbol: {
        color: '#BF00FF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BF00FF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-DRIVEWAY-PAVER': {
      geometryType: 'polygon',
      symbol: {
        color: '#566081',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#566081',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-DRIVEWAY-UNPAVED': {
      geometryType: 'polygon',
      symbol: {
        color: '#AAFFAA',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#AAFFAA',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-GUTTER': {
      geometryType: 'polygon',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-PARKING-ASPH': {
      geometryType: 'polygon',
      symbol: {
        color: '#EAAAFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#EAAAFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-PARKING-CONC': {
      geometryType: 'polygon',
      symbol: {
        color: '#7EBD9D',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#7EBD9D',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-PARKING-PAVER': {
      geometryType: 'polygon',
      symbol: {
        color: '#BD9D7E',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BD9D7E',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-PARKING-UNPAVED': {
      geometryType: 'polygon',
      symbol: {
        color: '#7EBD8D',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#7EBD8D',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-PAVEMARK-POLY': {
      geometryType: 'polygon',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-PAVEMARK-SYMBOL': {
      geometryType: 'polygon',
      symbol: {
        color: '#00FF00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FF00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-ROAD-ASPH': {
      geometryType: 'polygon',
      symbol: {
        color: '#0000FF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#0000FF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-ROAD-CONC': {
      geometryType: 'polygon',
      symbol: {
        color: '#AABFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#AABFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-ROAD-PAVER': {
      geometryType: 'polygon',
      symbol: {
        color: '#7E7EBD',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#7E7EBD',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-ROAD-UNPAVED': {
      geometryType: 'polygon',
      symbol: {
        color: '#816000',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#816000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-SHOULDER-PAVED': {
      geometryType: 'polygon',
      symbol: {
        color: '#BD7E9D',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BD7E9D',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-SHOULDER-UNPAVED': {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-WALK-ASPH': {
      geometryType: 'polygon',
      symbol: {
        color: '#FFAAFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFAAFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-WALK-CONC': {
      geometryType: 'polygon',
      symbol: {
        color: '#814000',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#814000',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-WALK-PAVER': {
      geometryType: 'polygon',
      symbol: {
        color: '#685645',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#685645',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'R-WALK-UNPAVED': {
      geometryType: 'polygon',
      symbol: {
        color: '#9DBD7E',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#9DBD7E',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'S-CANAL': {
      geometryType: 'polygon',
      symbol: {
        color: '#7EADBD',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#7EADBD',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'S-DECK': {
      geometryType: 'polygon',
      symbol: {
        color: '#BDBD00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BDBD00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'S-DOCK': {
      geometryType: 'polygon',
      symbol: {
        color: '#00BDBD',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00BDBD',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'U-GAS-TANK': {
      geometryType: 'polygon',
      symbol: {
        color: '#005EBD',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#005EBD',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'U-SOLAR': {
      geometryType: 'polygon',
      symbol: {
        color: '#45685F',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#45685F',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'U-UTILITY-BOX': {
      geometryType: 'polygon',
      symbol: {
        color: '#00FF00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FF00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'U-UTILITY-ROOF': {
      geometryType: 'polygon',
      symbol: {
        color: '#6081',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#6081',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'U-UTILITY-STRUCTURE': {
      geometryType: 'polygon',
      symbol: {
        color: '#AAFFBF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#AAFFBF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'V-DITCH': {
      geometryType: 'polygon',
      symbol: {
        color: '#7EBD7E',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#7EBD7E',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'V-GRAVEL': {
      geometryType: 'polygon',
      symbol: {
        color: '#8181',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#8181',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'V-RIPRAP': {
      geometryType: 'polygon',
      symbol: {
        color: '#8D7EBD',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#8D7EBD',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'V-ROCKOUTCROP': {
      geometryType: 'polygon',
      symbol: {
        color: '#BDBD7E',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#BDBD7E',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'V-SHRUB': {
      geometryType: 'polygon',
      symbol: {
        color: '#00811F',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00811F',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'V-ParkLINE': {
      geometryType: 'polygon',
      symbol: {
        color: '#6800',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#6800',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'V-VEGETATION': {
      geometryType: 'polygon',
      symbol: {
        color: '#FFFF00',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#FFFF00',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'W-WATER': {
      geometryType: 'polygon',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Line',
        outlineColor: '#00FFFF',
        outlineWidth: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-CONC-EDGE': {
      geometryType: 'polyline',
      symbol: {
        color: '#FFEAAA',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-CURB-BOTTOM': {
      geometryType: 'polyline',
      symbol: {
        color: '#BD005E',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-CURB-TOP': {
      geometryType: 'polyline',
      symbol: {
        color: '#BD7E8D',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-FLOWLINE': {
      geometryType: 'polyline',
      symbol: {
        color: '#BD8D00',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-GUTTER': {
      geometryType: 'polyline',
      symbol: {
        color: '#8DBD7E',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-OBSTRUCTION': {
      geometryType: 'polyline',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-ROAD-CENTER': {
      geometryType: 'polyline',
      symbol: {
        color: '#818100',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-ROAD-EDGE': {
      geometryType: 'polyline',
      symbol: {
        color: '#003FFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-RW-BOTTOM': {
      geometryType: 'polyline',
      symbol: {
        color: '#AAAAFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-RW-TOP': {
      geometryType: 'polyline',
      symbol: {
        color: '#AAD4FF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-BREAKLINE-WALK-EDGE': {
      geometryType: 'polyline',
      symbol: {
        color: '#D4AAFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'A-ROAD-CENTERLINE': {
      geometryType: 'polyline',
      symbol: {
        color: '#FFFFFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'B-FOOTPRINT': {
      geometryType: 'polyline',
      symbol: {
        color: '#D4FFAA',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'B-FOOTPRINT-OBSTRUCTED': {
      geometryType: 'polyline',
      symbol: {
        color: '#007FFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'D-SPAN-VECTOR': {
      geometryType: 'polyline',
      symbol: {
        color: '#AAEAFF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'G-TOPO-MAJR': {
      geometryType: 'polyline',
      symbol: {
        color: '#808080',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'G-TOPO-MINR': {
      geometryType: 'polyline',
      symbol: {
        color: '#414141',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'R-PAVEMARK-LINE': {
      geometryType: 'polyline',
      symbol: {
        color: '#FF0000',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'R-RAILROAD': {
      geometryType: 'polyline',
      symbol: {
        color: '#BD008D',
        Fill: 'none',
        style: 'Dash',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'S-FENCE': {
      geometryType: 'polyline',
      symbol: {
        color: '#ADBD7E',
        Fill: 'none',
        style: 'Dash',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'S-FENCE-GATE': {
      geometryType: 'polyline',
      symbol: {
        color: '#00FFFF',
        Fill: 'none',
        style: 'Dash',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'S-GUARDRAIL': {
      geometryType: 'polyline',
      symbol: {
        color: '#FFBFAA',
        Fill: 'none',
        style: 'Dash',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'S-RAILING': {
      geometryType: 'polyline',
      symbol: {
        color: '#FFD4AA',
        Fill: 'none',
        style: 'Dash',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'S-WALL': {
      geometryType: 'polyline',
      symbol: {
        color: '#BD7EAD',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'S-WALL-CONC': {
      geometryType: 'polyline',
      symbol: {
        color: '#567681',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'S-WALL-STONE': {
      geometryType: 'polyline',
      symbol: {
        color: '#414141',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'T-COMM-DROP': {
      geometryType: 'polyline',
      symbol: {
        color: '#FFAA00',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'T-COMM-WIRE': {
      geometryType: 'polyline',
      symbol: {
        color: '#FFAA00',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'T-GUY-OVERHEAD': {
      geometryType: 'polyline',
      symbol: {
        color: '#55FF00',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'T-GUY-WIRE': {
      geometryType: 'polyline',
      symbol: {
        color: '#55FF00',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'T-POWER-DROP': {
      geometryType: 'polyline',
      symbol: {
        color: '#0000FF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'T-POWER-WIRE': {
      geometryType: 'polyline',
      symbol: {
        color: '#0000FF',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'U-OVERHEAD-DROP': {
      geometryType: 'polyline',
      symbol: {
        color: '#818156',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'U-OVERHEAD-GUY': {
      geometryType: 'polyline',
      symbol: {
        color: '#564568',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
    'U-OVERHEAD-WIRE': {
      geometryType: 'polyline',
      symbol: {
        color: '#BD002E',
        Fill: 'none',
        style: 'Line',
        width: 1,
      },
      RendererType: 'Simple',
    },
  },
};
